import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyBs3xRd2kCLpZ6r6VwysjCdA7Id9URUqrw',
  authDomain: 'clone-560c4.firebaseapp.com',
  databaseURL: 'https://clone-560c4.firebaseio.com',
  projectId: 'clone-560c4',
  storageBucket: 'clone-560c4.appspot.com',
  messagingSenderId: '226924163242',
  appId: '1:226924163242:web:4e20c3c05843a4aa0ca0d3',
  measurementId: 'G-7MR6VLBNPS',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
